const getProductsWithOneImage = products => {
  return products.map((product: any) => ({
    ...product,
    image: product.imagesUrls[0]
  }));
};

export { getProductsWithOneImage };
